/** @file tileFitImage: a dropped or pasted image fitted to the tile size (pad centred, or scale nearest). */
import { blitImage } from '@zilo/pose3d-image-io/image/blitImage';
import { createImage } from '@zilo/pose3d-image-io/image/createImage';
import { resampleImage } from '@zilo/pose3d-image-io/image/resampleImage';
import type { Image } from '@zilo/pose3d-image-io/types/image';
import type { FitMode } from '../../panels/art/artTypes';

/**
 * `image` unchanged when it has `size`; else `pad` centres it on a transparent tile (offset `floor((size - image) / 2)`,
 * what overflows is cropped, as the server's slot fit does) and `scale` resamples it nearest-neighbour (pixel art).
 */
export function tileFitImage(image: Image, size: readonly [number, number], mode: FitMode): Image {
  const [w, h] = size;
  if (image.width === w && image.height === h) return image;
  if (mode === 'scale') return resampleImage(image, w, h, 'nearest');
  const out = createImage(w, h);
  blitImage(out, image, Math.floor((w - image.width) / 2), Math.floor((h - image.height) / 2));
  return out;
}
